import {USER_ROLE} from './user';

export interface Newsletter {
  id: string;
  content: string;
  rolesArray: USER_ROLE[];
  creationDate: Date;
  lastModificationDate: Date;
  startDate: Date | null;
  endDate: Date | null;
  alertLevel: string;
  zonesArray: NEWSLETTER_ZONE[] | null;
  recurrenceOptions: NEWSLETTER_RECURRENCE[] | null;
}

export enum NEWSLETTER_ZONE {
  DASHBOARD = 'dashboard',
  ORDER_CREATION_ADDRESSES = 'order-creation-addresses',
  ORDER_CREATION_DATE = 'order-creation-date',
  EVALUATION = 'evaluation'
}

export enum NEWSLETTER_RECURRENCE {
  NONE = 'none',
  EACH_YEAR = 'each-year',
  EACH_MONTH = 'each-month'
}
